import React from 'react';
import { Content } from './shared';

const UniversalPap = () => (
  <Content>
    Due for a Pap smear? Ask your primary care physician if you qualify for a free exam.
  </Content>
);

export default UniversalPap;
